import { wordForm } from "@/utils/text/wordForm";

export const FORMAT_ERROR = "Неверный формат";
export const REQUIRED_ERROR = "Обязательное поле";
export const RANGE_ERROR = "Некорректный интервал";
export const NUMBER_RANGE_ERROR = "Некорректный диапазон";
export const PERIOD_ERROR = "Некорректный период";
export const TIME_FORMAT_ERROR = "Неверный формат";
export const DATE_FORMAT_ERROR = "Неверный формат";
export const EMAIL_ERROR = "Неверный формат";
export const PHONE_ERROR = "Неверный формат";
export const REQUIRED_VARIANTS_ERROR = "Необходимо выбрать хотя бы один вариант";

export const MIN_CHARS_ERROR = (chars) => {
    const word = wordForm(chars, ["символ", "символов", "символов"]);
    return `Введите не менее ${chars} ${word}`;
};

export const errors = {
    required: REQUIRED_ERROR,
    date: {
        wrongValue: "Некорректное значение",
        wrongFormat: "Неверный формат",
    },
};
